import { render, staticRenderFns } from "./matchGraph.vue?vue&type=template&id=034a48d0&scoped=true&"
import script from "./matchGraph.vue?vue&type=script&lang=js&"
export * from "./matchGraph.vue?vue&type=script&lang=js&"
import style0 from "./matchGraph.vue?vue&type=style&index=0&id=034a48d0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034a48d0",
  null
  
)

export default component.exports